import React, { useState } from 'react';
import { FaRegEdit } from 'react-icons/fa';

export default function Bannerbuttonedit() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleEditClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {/* Edit Button */}
      <div
        onClick={handleEditClick}
        className="cursor-pointer border-2 h-9 w-60 bg-gray-300 mt-2 flex gap-1 justify-center"
      >
        <h1 className="h-full text-center pt-2 text-lg">
          <FaRegEdit />
        </h1>
        <h1 className="mt-1.5">Edit</h1>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white  p-2 rounded-lg shadow-lg w-[43%] relative">
            {/* Close Icon */}
            <button
              onClick={handleCloseModal}
              className="absolute top-2 right-3 text-gray-600 text-xl font-bold hover:text-black"
            >
              &times;
            </button>
            <div className='p-3'>
              <h1 className="text-xl font-semibold mb-1  ">1 Banner Content</h1>
              <h1>This From Form 1st Banner Conetent </h1>
            </div>

            <div className='mt-4 ms-6 p-4'>
              <h1 className='border-b-2 text-gray-400'>
                Primary Button - give text For your Primary Button
                <span className="text-red-500 ml-1">*</span>
              </h1>
            </div>
            <div className='mt-4 ms-6 p-4'>
              <h1 className='border-b-2 text-gray-400 '>
                Primary Button - give text For your Primary Button
              </h1>
            </div>



            <div className='flex justify-end'>
              <button class="bg-blue-500 hover:bg-blue-700 text-white mr-6 mt-3 py-2 px-8 rounded">
                Add
              </button>
            </div>


          </div>
        </div>
      )}
    </>
  );
}
